import { Route, Routes } from "react-router";
import Main from "./pages/main/Main";

const Router = () => {
  return (
    <Routes>
      <Route path='/' element={<Main />} />
    </Routes>
  );
};

export default Router;
